/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ApiCaller from "~/api/ApiCaller";
import {
  GetReportResponse,
  GetResellerReportsMetadataResponse,
  PostDeleteReportResponse,
  ReportDeleteRequest,
  ReportRequest,
} from "~/features/reportTracker/types";
import { StatisticsDownloadResponseData } from "~/features/statistics/types";

const ReportApi = {
  getResellerReportsMetadata: () => ApiCaller.get<GetResellerReportsMetadataResponse>("/v1/report/reportsmetadata"),
  postGetReport: (payload: ReportRequest) => ApiCaller.post<GetReportResponse>("/v1/report/report", payload),
  deleteReport: (payload: ReportDeleteRequest) =>
    ApiCaller.post<PostDeleteReportResponse>("/v1/report/deletereport", payload),
  postDownloadReport: (payload: ReportRequest) =>
    ApiCaller.post<StatisticsDownloadResponseData>("/v1/report/downloadreport", payload),
  postGetAutomaticReport: (payload: ReportRequest) =>
    ApiCaller.post<GetReportResponse>("/v1/report/autoloadreport", payload),
};

export default ReportApi;
